"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isNetworkErrorRecoverable(shaka, error) {
    if (error.category !== shaka.util.Error.Category.NETWORK) {
        return false;
    }
    switch (error.code) {
        case shaka.util.Error.Code.OPERATION_ABORTED:
        case shaka.util.Error.Code.BAD_HTTP_STATUS:
        case shaka.util.Error.Code.HTTP_ERROR:
        case shaka.util.Error.Code.TIMEOUT:
            return true;
    }
    return false;
}
exports.default = isNetworkErrorRecoverable;
//# sourceMappingURL=isNetworkErrorRecoverable.js.map